import { render } from "./App.vue?vue&type=template&id=04a0c3f9"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=04a0c3f9&lang=css"

import exportComponent from "C:\\Users\\brettp\\Documents\\Workspaces\\vue_plate_tool\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__